import AccessControlEntryRequest from "./AccessControlEntryRequest";

export default class AdminUpdateUserApiRequest {
  userId: number;
  email: string;
  name: string;
  accessControlEntries: AccessControlEntryRequest[];
  constructor(userId: number, email: string, name: string, accessControlEntries: AccessControlEntryRequest[]) {
    this.userId = userId;
    this.email = email;
    this.name = name;
    this.accessControlEntries = accessControlEntries;
  }
}
